





























import { HelperMethods } from '@/core/HelperMethods';
import { GuildViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Guild extends Vue {
    @Prop({ required: true, type: Number })
    realmId!: number;

    @Prop({ required: true, type: Object })
    guild!: GuildViewObject;

    get leader() {
        return this.guild.leader.character;
    }

    get classColor() {
        return HelperMethods.GetClassColor(this.leader.class);
    }

    get members() {
        return this.guild.members;
    }

    get link() {
        return `/armory/${this.realmId}/guild/${this.guild.name}`;
    }
}
